import DelegationDetailsResponse, {
  DelegationDetailsResponseItem,
  DelegationDetailsResponseItemAddressSequenceNodeGroup,
  DelegationDetailsResponseItemAddressSequence,
  DelegationDetailsResponseItemAddressSequenceNode,
  DelegationDetailsResponseItemMileageData,
} from "../../../api/raily/delegation/details/delegation-details.response";
import DelegationDetails, {
  DelegationDetailsAddressNode,
  DelegationDetailsMileageData,
} from "./delegation-details";

const createAddress = (
  address: DelegationDetailsResponseItemAddressSequenceNode,
): DelegationDetailsAddressNode => {
  return {
    displayName: address.displayName,
    lat: address.lat,
    lon: address.lon,
    time: address.time,
  };
};

const createAddressGroup = (
  group: DelegationDetailsResponseItemAddressSequenceNodeGroup,
): DelegationDetailsAddressNode[] => {
  return group.nodes.map(createAddress);
};

const createAddressSequence = (
  seq: DelegationDetailsResponseItemAddressSequence,
): DelegationDetailsAddressNode[][] => {
  return seq.seq.map(createAddressGroup);
};

const createMileageDataItem = (
  item: DelegationDetailsResponseItemMileageData,
): DelegationDetailsMileageData => {
  return {
    humanId: item.humanId,
  };
};

const createMileageData = (
  data: DelegationDetailsResponseItemMileageData[],
): DelegationDetailsMileageData[] => {
  return data.map(createMileageDataItem);
};

const createDetails = (
  item: DelegationDetailsResponseItem,
): DelegationDetails => {
  return {
    addressSequence: createAddressSequence(item.addressSeq),
    mileageData: createMileageData(item.mileageData),
    workerName: item.workerName,
    workerPhone: item.workerPhone,
    workerUuid: item.workerId,
  };
};

const create = (response: DelegationDetailsResponse): DelegationDetails => {
  return createDetails(response.data);
};

const delegationDetailsFactory = {
  create,
};

export default delegationDetailsFactory;
